<script>
    import Icon from './Icon.svelte';
    import checkIcon from '../assets/icons/checkmark.svg?raw';
    import failedIcon from '../assets/icons/failed.svg?raw';
    import questionIcon from '../assets/icons/question.svg?raw';
    import forbiddenIcon from '../assets/icons/forbidden.svg?raw';
    import stopIcon from '../assets/icons/stop.svg?raw';

    import Box from './Box.svelte';

    let { children, icon } = $props();

    const role = $derived(icon === 'failed' || icon === 'question' ? 'alert' : 'status');
</script>

<br>

<Box>
    <div class="status {icon}" {role}>
        <div class="icon" aria-hidden="true">
            {#if icon === 'success'}
                <Icon data={checkIcon} />
            {/if}

            {#if icon === 'failed'}
                <Icon data={failedIcon} />
            {/if}

            {#if icon === 'question'}
                <Icon data={questionIcon} />
            {/if}

            {#if icon === 'forbidden'}
                <Icon data={forbiddenIcon} />
            {/if}

            {#if icon === 'stop'}
                <Icon data={stopIcon} />
            {/if}
        </div>
        
        <div class="message">
            {@render children?.()}
        </div>
    </div>
</Box>

<style>
    .status {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1.5em;
        padding: 1em 0;
        text-align: center;
    }

    .icon {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--accent-background);
    }

    .success .icon {
        color: var(--success-color);
    }

    .failed .icon,
    .forbidden .icon,
    .stop .icon {
        color: var(--failed-color);
    }


    .question .icon {
        color: #888;
    }

    .icon :global(svg) {
        width: 96px;
        height: 96px;
    }

    .message {
        font-size: 1.1em;
        font-weight: 600;
        color: var(--text-color);
    }
</style>